"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sizer = void 0;
var event_emitter_1 = require("./event-emitter");
var Sizer = /** @class */ (function (_super) {
    __extends(Sizer, _super);
    function Sizer(canvas) {
        var _this = _super.call(this) || this;
        _this.canvas = canvas;
        _this.pixelRatio = Math.min(window.devicePixelRatio, 2);
        _this.initSizingMechanic();
        return _this;
    }
    Sizer.prototype.initSizingMechanic = function () {
        this.sizing();
        window.addEventListener('resize', this.sizing.bind(this));
    };
    Sizer.prototype.sizing = function () {
        var rect = this.canvas.parentElement.getBoundingClientRect();
        this.width = rect.width;
        this.height = rect.height;
        this.trigger('resize', [this.width, this.height]);
    };
    return Sizer;
}(event_emitter_1.EventEmitter));
exports.Sizer = Sizer;
